import { EventBus } from "../index.js";

export default {
	data: function () {
		return {
			currentSort: {
				name: "name",
				ascending: true,
				numerical: false
			},
			byAssetClass: false,
			priceType: "nav",
			fundsToCompare: [],
			tableHeader: {
				stuck: false,
				height: 0
			}
		};
	},
	mounted() {
		EventBus.$on("asset_class_toggled", () => {
			// Sync the two asset class buttons
			this.byAssetClass = !this.byAssetClass;
		});

		EventBus.$on("window:scroll", this.detectSticky);

		/*
		 * Calculate height of table headers (need to make both active for a split second to get
		 * height of yield because it's hidden by default). Used for the full width sticky bar that sits
		 * under the table header.
		 */

		let tabs = document.querySelectorAll(".tab-panel");
		for (let i = 0; i < tabs.length; ++i) {
			tabs[i].classList.add("active");
		}
		this.tableHeader.height = this.$refs.aiTableHeader.clientHeight;
		for (let i = 1; i < tabs.length; ++i) {
			tabs[i].classList.remove("active");
		}
	},
	computed: {
		sortedFunds: function () {
			return this.funds.slice().sort((a, b) => {
				let modifier = 1; // For ascending vs descending
				if (!this.currentSort.ascending) modifier = -1;

				if (this.byAssetClass) {
					if (a.asset_class.type === b.asset_class.type) {
						// Sorting within same asset class type

						if (a.isAssetClass) {
							// If a is an asset class row it should come before b
							return -1;
						} else if (b.isAssetClass) {
							// If b is an asset class row a should come after it
							return 1;
						}

						if (this.currentSort.numerical) {
							return this.sortByNumber(a, b, this.currentSort, modifier);
						} else {
							return this.sortByString(a, b, this.currentSort, modifier);
						}
					} else {
						// Sorting asset groups
						return a.asset_class.type < b.asset_class.type ? -1 : 1;
					}
				} else {
					if (a.isAssetClass || b.isAssetClass) return; // Ignore if comparing against an asset row

					if (this.currentSort.numerical) {
						return this.sortByNumber(a, b, this.currentSort, modifier);
					} else {
						return this.sortByString(a, b, this.currentSort, modifier);
					}
				}
			});
		}
	},
	methods: {
		addAssetClassRows: function (_funds) {
			// Get array of asset class types
			let assetClassRaw = _funds.map((a) => a.asset_class.type);
			let assetClassList = assetClassRaw.filter((assetClass, index) => {
				return assetClassRaw.indexOf(assetClass) >= index;
			});

			// Add a row for each asset class to this.funds
			assetClassList.forEach((assetClass) => {
				let assetClassRow = {};
				assetClassRow.isAssetClass = true;
				assetClassRow.asset_class = {};
				assetClassRow.asset_class.type = assetClass;
				assetClassRow.name = "1";
				_funds.push(assetClassRow);
			});

			return _funds;
		},
		sort: function (_sortName, _numerical) {
			if (_sortName === this.currentSort.name) {
				this.currentSort.ascending = !this.currentSort.ascending; // If sortName == current sort, reverse
			} else {
				this.currentSort.ascending = true; // Always start ascending on first click
			}

			this.currentSort.name = _sortName; // These two variables are used in the computed sortedFunds variable
			this.currentSort.numerical = _numerical;
		},
		sortByString: function (_a, _b, _sort, _modifier) {
			if (_a[_sort.name] < _b[_sort.name]) {
				return -1 * _modifier;
			} else if (_a[_sort.name] > _b[_sort.name]) {
				return 1 * _modifier;
			} else {
				return 0;
			}
		},
		sortByNumber: function (_a, _b, _sort, _modifier) {
			let aFloat;
			let bFloat;

			if (_a[_sort.name][this.priceType] && _b[_sort.name][this.priceType]) {
				// If it has a price type
				aFloat = parseFloat(_a[_sort.name][this.priceType]);
				bFloat = parseFloat(_b[_sort.name][this.priceType]);
			} else {
				// If it's just a number
				aFloat = parseFloat(_a[_sort.name]);
				bFloat = parseFloat(_b[_sort.name]);
			}

			// Put NaN at end of list
			if (isNaN(aFloat)) {
				return 1;
			} else if (isNaN(bFloat)) {
				return -1;
			}

			// Sort numbers
			if (aFloat < bFloat) return -1 * _modifier;
			if (aFloat > bFloat) return 1 * _modifier;
			return 0;
		},
		detectSticky: function () {
			// Tells us when the table header has stuck.
			const offsetTop = this.$refs.aiTableHeader.getBoundingClientRect().top;
			if (offsetTop < 0 && !this.tableHeader.stuck) {
				this.tableHeader.stuck = true;
			} else if (offsetTop >= 0 && this.tableHeader.stuck) {
				this.tableHeader.stuck = false;
			}
		},
		onRowCheck(e) {
			if (e.target.checked) {
				// add it to the fundsToCompare array
				EventBus.ai.fundsToCompare.push(e.target.value);
			} else {
				// remove it from the array
				EventBus.ai.fundsToCompare = EventBus.ai.fundsToCompare.filter(
					(val) => val !== e.target.value
				);
			}

			// then emit the array so that the CompareFundsBar can get the data
			EventBus.$emit("ai:compare_funds", EventBus.ai.fundsToCompare);
		},
		sendACEvent: function () {
			EventBus.$emit("asset_class_toggled");
		}
	}
};
